import {
  CustomAttributeReadAccessEnum,
  CustomAttributeTypeEnum,
  CustomAttributeWriteAccessEnum,
} from "suus-api"
import {
  mdiAccountCog,
  mdiAccountEdit,
  mdiAccountMultiple,
  mdiCalendar,
  mdiCalendarRange,
  mdiCheckboxMarked,
  mdiDecimalComma,
  mdiFormatTitle,
  mdiFormDropdown,
  mdiNumeric,
  mdiShieldAccount,
  mdiText,
} from "@mdi/js"

export const CUSTOM_ATTRIBUTE_TYPE_ICONS: Record<
  CustomAttributeTypeEnum,
  string
> = {
  [CustomAttributeTypeEnum.Integer]: mdiNumeric,
  [CustomAttributeTypeEnum.Float]: mdiDecimalComma,
  [CustomAttributeTypeEnum.String]: mdiFormatTitle,
  [CustomAttributeTypeEnum.Text]: mdiText,
  [CustomAttributeTypeEnum.Boolean]: mdiCheckboxMarked,
  [CustomAttributeTypeEnum.Date]: mdiCalendar,
  [CustomAttributeTypeEnum.FuzzyDate]: mdiCalendarRange,
  [CustomAttributeTypeEnum.Select]: mdiFormDropdown,
}

export const CUSTOM_ATTRIBUTE_READ_ACCESS_ICONS: Record<
  CustomAttributeReadAccessEnum,
  { icon: string; tooltip: string }
> = {
  [CustomAttributeReadAccessEnum.Admins]: {
    icon: mdiShieldAccount,
    tooltip: "Nur Admins können dieses Feld sehen.",
  },
  [CustomAttributeReadAccessEnum.Managers]: {
    icon: mdiAccountCog,
    tooltip: "Nur Adressverwalter und Admins können dieses Feld sehen.",
  },
  [CustomAttributeReadAccessEnum.Editors]: {
    icon: mdiAccountEdit,
    tooltip:
      "Nur Adressverwalter, Admins und Profilbesitzer können dieses Feld sehen.",
  },
  [CustomAttributeReadAccessEnum.Viewers]: {
    icon: mdiAccountMultiple,
    tooltip: "Alle können dieses Feld sehen.",
  },
}

export const CUSTOM_ATTRIBUTE_WRITE_ACCESS_ICONS: Record<
  CustomAttributeWriteAccessEnum,
  { icon: string; tooltip: string }
> = {
  [CustomAttributeWriteAccessEnum.Admins]: {
    icon: mdiShieldAccount,
    tooltip: "Nur Admins können dieses Feld bearbeiten.",
  },
  [CustomAttributeWriteAccessEnum.Managers]: {
    icon: mdiAccountCog,
    tooltip: "Nur Adressverwalter und Admins können dieses Feld bearbeiten.",
  },
  [CustomAttributeWriteAccessEnum.Editors]: {
    icon: mdiAccountEdit,
    tooltip:
      "Adressverwalter, Admins und Profilbesitzer können dieses Feld bearbeiten.",
  },
}
